import { useStorageContext } from '@app/contexts/storage';
import { MAIN_PAGE } from '@app/enums';
import { TInitModule } from '@app/interface';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React, { FC, useEffect, useState } from 'react';
import { init as initConfirmTranslate } from '../../modules/ConfirmTranslate';
import { init as initSelfConfig } from '../../modules/SelfConfig';
import { init as initTranslate } from '../../modules/Translate';
import { init as initUserConfig } from '../../modules/UserConfig';

const moduleAsyncImport: { [key in MAIN_PAGE]: () => TInitModule } = {
    [MAIN_PAGE.LOGOUT]: null,
    [MAIN_PAGE.TRANSLATE]: initTranslate,
    [MAIN_PAGE.CONFIRM_TRANSLATE]: initConfirmTranslate,
    [MAIN_PAGE.SELF_CONFIG]: initSelfConfig,
    [MAIN_PAGE.USER_CONFIG]: initUserConfig
};

export const ContentApp: FC = observer(() => {
    const { globalStorage } = useStorageContext();

    const [Render, changeRender] = useState<FC>(() => () => null);

    const asyncImportElement = moduleAsyncImport[globalStorage.openModule];

    useEffect(() => {
        if (asyncImportElement) {
            let tInitModule = asyncImportElement();
            runInAction(() => globalStorage.functionsButton.replace(tInitModule.buttonFunctions));
            changeRender(() => tInitModule.component);
        }
    });

    return <Render />;
});
